import CategoryTermsIcon from '@material-ui/icons/Description';
import CategoryTermsList from './CategoryTermsList';
import CategoryTermsEdit from './CategoryTermsEdit';
import CategoryTermsCreate from './CategoryTermsCreate';

export default {
  create: CategoryTermsCreate,
  list: CategoryTermsList,
  edit: CategoryTermsEdit,
  icon: CategoryTermsIcon
};
